import { usePastMemberElectionRuns } from "../_hooks/usePastMemberElectionRuns";
import PastMemberElectionRunsTable from "./PastMemberElectionRunsTable";

export default function PastMemberElectionsContent() {
  const { runs, loading, showLoadError, createHeaderPagination, createFooterPagination } = usePastMemberElectionRuns();

  return (
    <div className="w-full pt-12">
      <p className="body-medium text-sys-brand-on-surface-variant">
        Review prior finalize-election batches, including who initiated each run, how many applications were submitted,
        and the overall outcome.
      </p>
      <PastMemberElectionRunsTable
        loading={loading}
        runs={runs}
        showLoadError={showLoadError}
        createHeaderPagination={createHeaderPagination}
        createFooterPagination={createFooterPagination}
      />
    </div>
  );
}
